import { jsx } from "react/jsx-runtime";
import { PaymentInputFieldWUT } from "../../../ui/payment-input-field/payment-input-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const PaymentInputWUT = (props) => {
  const { fieldType = FIELD_TYPES.PAYMENT_INPUT } = props;
  return /* @__PURE__ */ jsx(PaymentInputFieldWUT, { ...props, fieldType });
};
export {
  PaymentInputWUT
};
//# sourceMappingURL=payment-input-wut.js.map
